import STATE from '../enums/state.js';
import onDocumentReady from '../utils/on-document-ready.js';

const classes = {
  description: 'description',
  block: 'block',
  hidden: 'hidden',
  cursorDefault: 'cursor-default',
};

const selectors = {
  description: '[data-collection-description]',
  content: '[data-collection-description-content]',
  readMoreSpan: '[data-read-more]',
};

class Description extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.description = this.element.querySelector(selectors.description);
    this.content = this.element.querySelector(selectors.content);
    this.readMoreSpan = this.element.querySelector(selectors.readMoreSpan);

    onDocumentReady(() => {
      if (this.content.clientHeight > 100) {
        this.init();
      }

      window.addEventListener('resize', () => {
        if (this.content.clientHeight > 100) {
          this.init();
        } else {
          this.removeAccordion();
        }
      });
    });
  }

  init() {
    this.createAccordion();
    this.initEventListeners();
  }

  get state() {
    return this.description.dataset.state;
  }

  setText(text) {
    this.readMoreSpan.textContent = text;
  }

  setState(state) {
    this.description.dataset.state = state;
  }

  createAccordion() {
    this.description.classList.add(classes.description);
    this.description.classList.remove(classes.cursorDefault);
    this.readMoreSpan.classList.remove(classes.hidden);
    this.readMoreSpan.classList.add(classes.block);
  }

  removeAccordion() {
    this.description.classList.remove(classes.description);
    this.description.classList.add(classes.cursorDefault);
    this.readMoreSpan.classList.add(classes.hidden);
    this.readMoreSpan.classList.remove(classes.block);
  }

  initEventListeners() {
    const { readMore, readLess } = window.translations.collection.accessibility;

    [this.readMoreSpan, this.description].forEach(selector => {
      selector.addEventListener('click', () => {
        if (this.state === STATE.DESCRIPTION.CLOSED) {
          this.setState(STATE.DESCRIPTION.OPEN);
          this.setText(readLess);
        } else {
          this.setState(STATE.DESCRIPTION.CLOSED);
          this.setText(readMore);
        }
      });
    });
  }
}

customElements.define('collection-description', Description);
